import { LuFilter } from "react-icons/lu";
import { NOTIFICATION_COLUMN_FILTERS } from "../../constants";
import "./NotificationColumnFilterButton.scss";

/**
 * Counts how many {@link NOTIFICATION_COLUMN_FILTERS} keys have a non-empty trimmed value in `filters`.
 *
 * @param {Record<string, unknown>} filters Current column filter values from parent state.
 * @returns {number} Number between `0` and `NOTIFICATION_COLUMN_FILTERS.length`.
 */
function countActiveFilters(filters) {
    return NOTIFICATION_COLUMN_FILTERS.reduce((count, { key }) => {
        const value = filters?.[key];
        return value != null && String(value).trim() !== ""
            ? count + 1
            : count;
    }, 0);
}

/**
 * Compact toolbar trigger for the column filter builder rendered above the notifications table.
 *
 * @param {object} props
 * @param {Record<string, string>} props.filters Applied column filters.
 * @param {boolean} props.expanded Whether the filter builder is expanded.
 * @param {(expanded: boolean) => void} props.onExpandedChange Toggles filter builder visibility.
 * @returns {import('react').JSX.Element}
 */
const NotificationColumnFilterButton = ({
    filters,
    expanded,
    onExpandedChange,
}) => {
    const activeCount = countActiveFilters(filters);
    const hasActiveFilters = activeCount > 0;

    return (
        <button
            type="button"
            className={`notification-column-filter-button${
                hasActiveFilters
                    ? " notification-column-filter-button--active"
                    : ""
            }`}
            aria-expanded={expanded}
            aria-controls="notification-column-filters-panel"
            onClick={() => onExpandedChange(!expanded)}
        >
            <LuFilter aria-hidden size={16} />
            <span>
                {hasActiveFilters
                    ? `${activeCount} column filter${activeCount === 1 ? "" : "s"}`
                    : "Column filters"}
            </span>
        </button>
    );
};

export default NotificationColumnFilterButton;
